<template>
    <b-card
        name="filterCard"
        header="Filter"
        class="col-sm-12 mx-auto mt-3"
        style="border-style: none"
    >
        <div class="mt-3">
            <b-row
                v-for="(rowItem, rowIndex) in filterItems"
                v-bind:key="rowIndex"
            >
                <b-col
                    v-for="(colItem, colIndex) in rowItem"
                    v-bind:key="colIndex"
                    :sm="colItem.colSize"
                >
                    <historyFilterWrapper
                        v-if="colItem.componentType && colItem.show"
                        v-model="filterModel[colItem.model]"
                        :componentType="colItem.componentType"
                        :attributes="colItem.attributes"
                        :label="colItem.label"
                        v-on="colItem.events"
                    />
                </b-col>
            </b-row>
            <b-row>
              <b-col sm="2">
                <b-button
                  class="btn-block"
                  variant="outline-secondary"
                  name="save_standard_filter"
                  label="Save Standard Filter"
                  @click="saveStandardFilter"
                >Save as Standard Filter</b-button>
              </b-col>
            </b-row>
        </div>
    </b-card>
</template>
<script>
  import store from '../../store';
  import { CORE_PREFIX, ACTIONS, MUTATIONS, HISTORY_PREFIX, GETTERS } from '../../store/constants';
  import vSelect from '../vSelect';
  import Datepicker from 'vuejs-datepicker';
  import { mapGetters } from 'vuex';
  import {addDays, format, subDays} from 'date-fns';
  import helpers from '../../helper';
  import historyFilterWrapper from './Wrapper/historyFilterWrapper';

  function initialFilterState(isClear) {
     
      let initialState = {
          fromDate: new Date(),
          toDate: new Date(),
          deliveryStatus: null,
          branchId: null,
          carrier: null,
          accountId: null,
          companyId: null,
          transportProductId: null,
          salesProductIds: null,
          withInsurance: null,
          shipping: null,
          invoicedStatus: null,
          shipmentDirection: null,
          searchText: '',
          searchOption: 'AWB',
          historyFilterDocuments: { withInvoice: null },
          document: null,
          deleted: false,
          preBooking: false,
          dangerousGoods: false,
          quoteBooking: false,
          documentedSelected: null,
          salesProductSelected: null,
          selectedSalesProduct: null,
          insuranceSelected: null,
          shipmentType: null,
          forcePrint: false,
          countryCode: null,
          shippingTypes: [],
      };
      
      if (isClear)
        return initialState;

      let stdFilter = localStorage.std_historyFilter;
      if (stdFilter){
          let savedFilter = JSON.parse(stdFilter);
          initialState = savedFilter
          let std_historyFromDiff = localStorage.std_historyFromDiff;
          if (std_historyFromDiff){
              if (parseInt(std_historyFromDiff) > 0) {
                initialState.fromDate = addDays(new Date(), parseInt(std_historyFromDiff));
              }
              else
                initialState.fromDate = subDays(new Date(), parseInt(std_historyFromDiff) * -1);
          }
          let std_historyToDiff = localStorage.std_historyToDiff;
          if (std_historyToDiff){
            if (parseInt(std_historyToDiff) > 0) {
              initialState.toDate = addDays(new Date(), parseInt(std_historyToDiff));
            }
            else
              initialState.toDate = subDays(new Date(), std_historyToDiff * -1);
          }
          return initialState;
      } else {
      }
    
      return initialState;
  }

  export default {
      components: {
          vSelect,
          Datepicker,
          historyFilterWrapper,
      },

      props: {
          spinnerLoading: Boolean,
          required: true,
      },

      watch: {
          'filterModel.fromDate': {
              handler(newdate) {
                  this.disabledDates.to = newdate;

                  if (this.filterModel.toDate < newdate) {
                      this.filterModel.toDate = newdate;
                  }
              },
          },
        'filterModel.toDate': {
            handler(newdate){
              this.disabledDates.from = newdate;
              
              if(this.filterModel.fromDate > newdate){
                this.filterModel.fromDate = newdate
              }
            }
        },
      },

      computed: {
          filterItems() {
              let filterItems = [
                  [
                      {
                          label: this.$t('history.label.FilterFrom'),
                          componentType: 'Datepicker',
                          model: 'fromDate',
                          attributes: {
                              class: 'form-control form-control-sm',
                              name: 'fromDatePicker',
                              showRequiredIcon: true,
                          },
                          show: true,
                      },
                      {
                          label: this.$t('history.label.FilterTo'),
                          componentType: 'Datepicker',
                          model: 'toDate',
                          attributes: {
                              class: 'form-control form-control-sm',
                              name: 'toDatePicker',
                              showRequiredIcon: true,
                          },
                          show: true,
                      },
                      {
                          label: this.$t('history.label.DeliveryStatus'),
                          componentType: 'vSelect',
                          model: 'deliveryStatus',
                          attributes: {
                              name: 'deliveryStatus',
                              placeholder: this.$t('history.placeholder.All'),
                              reduce: (status) => status,
                              options: this.getDeliveryStatuses,
                          },
                          show: true,
                      },
                  ],
                  [
                      {
                          label: this.$t('history.label.Branch'),
                          componentType: 'vSelect',
                          model: 'branchId',
                          attributes: {
                              name: 'userBranches',
                              placeholder: this.$t('history.placeholder.All'),
                              reduce: (branch) => branch.id,
                              options: this.getVisibleUserBranches,
                              label: 'name',
                          },
                          show: this.isAdminOrSuperUser,
                      },
                      {
                          label: this.$t('history.label.TransportCompany'),
                          componentType: 'vSelect',
                          model: 'carrier',
                          attributes: {
                              name: 'transportCompanies',
                              placeholder: this.$t('history.placeholder.All'),
                              reduce: (company) => company.value,
                              options: this.getTransportCompanies,
                          },
                          show: true,
                      },
                      {
                          label: this.$t('history.label.Account'),
                          componentType: 'vSelect',
                          model: 'accountId',
                          attributes: {
                              name: 'companyAccounts',
                              placeholder: this.$t('history.placeholder.All'),
                              reduce: (account) => account.id,
                              options: this.getCompanyAccounts,
                              label: 'displayName',
                          },
                          show: true,
                          events: { input: this.accountSelected },
                      },
                  ],
                  [
                      {
                          label: this.$t('history.label.Company'),
                          componentType: 'vSelect',
                          model: 'companyId',
                          attributes: {
                              name: 'companies',
                              placeholder: this.$t('history.placeholder.All'),
                              reduce: (company) => company.id,
                              options: this.getCompanies,
                              label: 'name',
                          },
                          events: { input: this.companySelected },
                          show: this.isAdminOrSuperUser,
                      },
                      {
                          label: this.$t('history.label.TransportProduct'),
                          componentType: 'vSelect',
                          model: 'transportProductId',
                          attributes: {
                              name: 'transportProducts',
                              placeholder: this.$t('history.placeholder.All'),
                              reduce: (p) => p.id,
                              options: this.getListOfTransportProducts,
                              label: 'internalName',
                          },
                          show: this.isAdminOrSuperUser,
                      },
                      {
                          label: this.$t('history.label.SalesProduct'),
                          componentType: 'vSelect',
                          model: 'selectedSalesProduct',
                          attributes: {
                              name: 'salesProducts',
                              placeholder: this.$t('history.placeholder.All'),
                              reduce: (p) => p.id,
                              options: this.getSalesProducts,
                              label: 'displayName',
                          },
                          show: true,
                      },
                  ],
                  [
                      {
                          label: this.$t('history.label.InsuranceConditions'),
                          componentType: 'vSelect',
                          model: 'insuranceSelected',
                          attributes: {
                              name: 'insurance',
                              placeholder: this.$t('history.placeholder.All'),
                              reduce: (condition) => condition.key,
                              options: this.insuranceConditions,
                              label: 'option',
                          },
                          events: { input: this.insuranceSelect },
                          show: true,
                      },
                      {
                          label: this.$t('history.label.Shipping'),
                          componentType: 'vSelectMultiSelect',
                          model: 'shippingTypes',
                          attributes: {
                            name: 'shipping',
                            placeholder: this.$t('history.placeholder.All'),
                            reduce: (shipping) => shipping.key,
                            options: this.shipping,
                            label: 'option',
                            multiple: true,
                            closeOnSelect: false,
                          },
                          events: { input: this.shippingSelect },
                          show: true,
                      },
                      {
                          label: this.$t('history.label.Documents'),
                          componentType: 'vSelect',
                          model: 'documentedSelected',
                          attributes: {
                              name: 'documents',
                              placeholder: this.$t('history.placeholder.All'),
                              reduce: (document) => document.option,
                              options: this.documents,
                              label: 'option',
                          },
                          events: { input: this.document },
                          show: true,
                      },
                  ],
                  [
                      {
                          label: this.$t('history.label.ShipmentDirection'),
                          componentType: 'vSelect',
                          model: 'shipmentType',
                          attributes: {
                              name: 'shipmentType',
                              placeholder: this.$t('history.placeholder.All'),
                              reduce: (direction) => direction.value,
                              options: this.getShipmentDirections,
                          },
                          show: true,
                      },
                      {
                          label: this.$t('history.label.SearchText'),
                          componentType: 'b-form-input',
                          model: 'searchText',
                          attributes: {
                              name: 'searchText',
                          },
                          inputEvent: this.filter,
                          events: {
                              input: (newValue) => (this.filterModel.searchText = newValue),
                          },
                          show: true,
                      },
                      {
                          label: this.$t('history.label.SearchOptions'),
                          componentType: 'vSelect',
                          model: 'searchOption',
                          attributes: {
                              name: 'searchOptions',
                              placeholder: this.$t('history.placeholder.All'),
                              reduce: (option) => option,
                              options: this.getSearchOptions,
                              label: 'option',
                              clearable: false,
                          },
                          events: {
                              input: (newValue) => (this.filterModel.searchOption = newValue),
                          },
                          show: true,
                      },
                  ],
                  [
                      {
                          label: this.$t('history.label.Deleted'),
                          componentType: 'b-form-checkbox',
                          model: 'deleted',
                          attributes: {
                              class: 'float-left',
                              name: 'deleted',
                          },
                          colSize: 4,
                          show: true,
                      },
                      {
                          label: this.$t('history.label.PreBooking'),
                          componentType: 'b-form-checkbox',
                          model: 'preBooking',
                          attributes: {
                              class: 'float-left',
                              name: 'prebooking',
                          },
                          colSize: 4,
                          show: true,
                      },
                      {
                        label: this.$t('history.label.Country'),
                        componentType: 'vSelect',
                        model: 'countryCode',
                        attributes: {
                          name: 'countries',
                          placeholder: this.$t('history.placeholder.ChooseCountry'),
                          reduce: (country) => country.countryCode,
                          options: this.getCountries,
                          label: 'countryName',
                        },
                        show: true,
                        colSize: 4,
                        events: { input: this.countriesSelected },
                      },
                  ],
                  [
                      {
                          label: this.$t('history.label.DangerousGoods'),
                          componentType: 'b-form-checkbox',
                          model: 'dangerousGoods',
                          attributes: {
                              class: 'float-left',
                              name: 'dangerousGoods',
                          },
                          show: true,
                      },
                      {
                          label: this.$t('history.label.Quote'),
                          componentType: 'b-form-checkbox',
                          model: 'quoteBooking',
                          attributes: {
                              class: 'float-left',
                              name: 'quoteBooking',
                          },
                          show: this.isAdminOrSuperUser,
                      },
                      {
                          componentType: 'b-button',
                          attributes: {
                              class: 'btn-block',
                              variant: 'outline-secondary',
                              name: 'filter',
                              label: this.$t('history.label.FilterButton'),
                              loading: this.spinnerLoading,
                          },
                          events: { click: this.filter },
                          colSize: 2,
                          show: true,
                      },
                      {
                          componentType: 'b-button',
                          attributes: {
                              class: 'btn-block',
                              variant: 'outline-secondary',
                              name: 'resetFilterButton',
                              label: this.$t('history.label.ResetFilterButton'),
                          },
                          events: { click: this.resetFilter },
                          colSize: 1,
                          show: true,
                      },
                    {
                      componentType: 'b-button',
                      attributes: {
                        class: 'btn-block',
                        variant: 'outline-secondary',
                        name: 'clearFilterButton',
                        label: this.$t('history.buttons.Clear'),
                      },
                      events: { click: this.clearFilter },
                      colSize: 1,
                      show: true,
                    },
                  ],
              ];

              if (this.isCustomer) {
                  filterItems[1][0] = filterItems[1][2];
                  filterItems[2][0] = filterItems[3][0];
                  filterItems[3][0] = filterItems[4][0];
                  filterItems[4][0] = filterItems[5][0];
                  filterItems[5][0] = filterItems[6][0];
                  filterItems[6][0] = {};

                  filterItems[2][1] = filterItems[3][1];
                  filterItems[3][1] = filterItems[4][1];
                  filterItems[4][1] = filterItems[5][1];
                  filterItems[5][1] = {};

                  filterItems[1][2] = filterItems[2][2];
                  filterItems[2][2] = filterItems[3][2];
                  filterItems[3][2] = filterItems[4][2];
                  filterItems[4][2] = filterItems[5][2];

                  filterItems[5][1] = filterItems[6][1];
                  filterItems[5][2] = filterItems[6][2];
                  filterItems[5][3] = filterItems[6][3];

                  filterItems[6][1] = {};
                  filterItems[6][2] = {};
                  filterItems[6][3] = {};
              }
              else{
                if(this.$route.query.documentPack){
                    filterItems.push(
                        [
                          {
                            label: this.$t('history.label.ForcePrint'),
                            componentType: 'b-form-checkbox',
                            model: 'forcePrint',
                            attributes: {
                              class: 'float-left',
                              name: 'forcePrint',
                            },
                            colSize:4,
                            show: true,
                          },
                          {
                            componentType: 'b-button',
                            attributes: {
                              class: 'btn-block',
                              variant: 'outline-secondary',
                              name: 'documentPackButton',
                              label: this.$t('history.buttons.DocumentPack'),
                            },
                            events: { click: this.filterDocPack },
                            colSize: 2,
                            show: true,
                          }
                        ]
                    )
                }
              }

              return filterItems;
          },

          ...mapGetters('core', [
              'getListOfTransportProducts',
              'getUserData',
              'isCustomer',
              'isAdminOrSuperUser',
              'getCompanies',
              'getVisibleUserBranches',
              'getCountries'
          ]),
          ...mapGetters('history', [
              'getShipmentDirections',
              'getDeliveryStatuses',
              'getSalesProducts',
              'getTransportCompanies',
              'getSearchOptions',
              'getCompanyAccounts',
          ]),
      },

      data() {
          return {
              disabledDates: { to: new Date(), from: new Date(), days: [6, 0] },

              selectedCompanyId: null,
              filterModel: initialFilterState(),

              insuranceConditions: [
                  { option: this.$t('history.dropdowns.WithInsurance'), key: 'WithInsurance' },
                  { option: this.$t('history.dropdowns.WithoutInsurance'), key: 'WithoutInsurance' },
              ],
              shipping: [
                  { option: this.$t('history.dropdowns.EuropeanUnion'), key: 'EU' },
                  { option: this.$t('history.dropdowns.NonEuropeanUnion'), key: 'NonEU' },
                  { option: this.$t('history.dropdowns.Domestic'), key: 'Domestic' },
              ],
              invoicedStatus: [
                  { option: this.$t('history.dropdowns.Invoiced') },
                  { option: this.$t('history.dropdowns.NonInvoiced') },
              ],
              documents: [
                  { option: this.$t('history.dropdowns.WithInvoice') },
                  { option: this.$t('history.dropdowns.WithoutInvoice') },
              ],
          };
      },

      created() {
          var storeFilter = this.$store.getters[HISTORY_PREFIX + GETTERS.HISTORY.GET_FILTER];
          if (storeFilter != null) {
              const clone = helpers.cloneObject(storeFilter);
              clone.fromDate = storeFilter.fromDate;
              clone.toDate = storeFilter.toDate;
              this.filterModel = clone;
          }

          this.filter();
          
          let accounts = this.getCompanyAccounts
          let companies = this.getCompanies;
          if (companies.length > 1){
              this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_ALL_COMPANY_ACCOUNTS,null)
            let accounts = this.getCompanyAccounts
          }

          this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);
      },

      methods: {
          saveStandardFilter() {
              //Find difference between to dates
              const diffFromDate = this.filterModel.fromDate.getDate() -new Date().getDate();
              const diffToDate = this.filterModel.toDate.getDate() -new Date().getDate();
              
              this.filterModel.diffFromDate = diffFromDate;
              this.filterModel.diffToDate = diffToDate;
              
              localStorage.std_historyFromDiff = diffFromDate;
              localStorage.std_historyToDiff = diffToDate;
            
              localStorage.std_historyFilter = JSON.stringify(this.filterModel);
          },
          findSalesProductIds() {
              this.filterModel.salesProductIds = null;

              if (this.filterModel.selectedSalesProduct == Number.MAX_SAFE_INTEGER) {
                  const selectedSalesProduct = this.getSalesProducts.find(
                      (x) => x.id == Number.MAX_SAFE_INTEGER
                  );

                  this.filterModel.salesProductIds = selectedSalesProduct.underlyingSalesProducts;
              } else if (this.filterModel.selectedSalesProduct != null) {
                  this.filterModel.salesProductIds = [this.filterModel.selectedSalesProduct];
              }
          },
          filterDocPack(){
            const userData = this.getUserData;
            if (this.isCustomer) {
              this.filterModel.companyId = userData.companyId;
            }
            this.filterModel.testBooking = userData.testMode;
            this.$emit('fetchDocumentPack', this.filterModel);
            this.$emit('filterExcecute');
            this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.SET_SELECTED_ROWS, []);
          },
          filter() {
              this.findSalesProductIds();

              const userData = this.getUserData;

              if (this.isCustomer && this.getCompanies.length !== 1) {
                  this.filterModel.companyId = userData.companyId;
              }
            
              this.filterModel.testBooking = userData.testMode;

              this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.SET_FILTER, this.filterModel);

              this.filterModel.search = {
                  SearchText: this.filterModel.searchText,
                  SearchOption: this.filterModel.searchOption,
              };

              this.$emit('fetchHistoryShipments', this.filterModel);
              this.$emit('filterExcecute');
              this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.SET_SELECTED_ROWS, []);
          },
          resetFilter() {
              let initialState = initialFilterState();
              Object.assign(this.$data.filterModel, initialState);
          },
          clearFilter(){
            let initialState = initialFilterState(true);
            Object.assign(this.$data.filterModel, initialState);
          },

          async companySelected(companyId) {
              //If company is cleared, fetch all accounts and products
              if (companyId === null) {
                  await this.$store.dispatch(
                      HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_ALL_COMPANY_ACCOUNTS
                  );
                  await this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_SALES_PRODUCTS);

                  this.selectedCompanyId = null;
              }

              //If company is selected, use that companyId to fetch accounts and products
              else {
                  this.selectedCompanyId = companyId;

                  await this.$store.dispatch(
                      HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_COMPANY_ACCOUNTS,
                      companyId
                  );

                  await this.$store.dispatch(
                      HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_SALES_PRODUCTS_BY_COMPANYID,
                      companyId
                  );
              }
          },

          async accountSelected(accountId) {
              //If account is cleared,
              if (accountId === null) {
                  //If a company is already selected, use that companyId
                  if (this.selectedCompanyId != null) {
                      await this.$store.dispatch(
                          HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_SALES_PRODUCTS_BY_COMPANYID,
                          this.selectedCompanyId
                      );
                  }

                  //If no company is selected
                  else {
                      //if customer - use companyId from store
                      if (this.isCustomer) {
                          await this.$store.dispatch(
                              CORE_PREFIX + ACTIONS.CORE.FETCH_COMPANY_ACCOUNTS
                          );
                      }

                      //if not customer, fetch all
                      else {
                          await this.$store.dispatch(
                              HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_SALES_PRODUCTS
                          );
                      }
                  }
              }

              //If an account is selected, fetch sales products by that accountId
              else {
                  await this.$store.dispatch(
                      HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_SALES_PRODUCTS_BY_ACCOUNTID,
                      accountId
                  );
              }
          },

          document(selected) {
              this.filterModel.historyFilterDocuments.withInvoice = null;

              if (selected === 'With invoice') {
                  this.filterModel.historyFilterDocuments.withInvoice = true;
              }

              if (selected === 'Without invoice') {
                  this.filterModel.historyFilterDocuments.withInvoice = false;
              }
          },
          insuranceSelect(selected) {
              this.filterModel.withInsurance = null;
              if (selected === 'WithInsurance') {
                  this.filterModel.withInsurance = true;
              }
              if (selected === 'WithoutInsurance') {
                  this.filterModel.withInsurance = false;
              }
          },
          
          countriesSelected(selected){
            this.filterModel.countries = null;
            if (selected !== null) {
              this.filterModel.countryCode = selected;
            }
          },

        shippingSelect(selected) {
          if (!selected) {
            this.filterModel.shippingTypes = [];
            return;
          }

          this.filterModel.shippingTypes = Array.isArray(selected)
              ? selected
              : [selected];
        }
      }
  };
</script>
<style scoped>
  .button-filter-reset {
      width: 50%;
  }

  .card-body {
      border: 1px solid rgba(0, 0, 0, 0.125);
  }
</style>
